import { createSlice } from "@reduxjs/toolkit";
import { OmuniStateProps } from "../interfaces/reducers";

const initialState: OmuniStateProps = {
    fetching: "unknown",
    data: [],
    error: "",
    fetchingPut: "unknown"
};

const omuniSlice = createSlice({
    name: "omuni",
    initialState,
    reducers: {
        postOmuniRequest: (state) => {
            state.fetching = "loading";
        },
        postOmuniSuccess: (state, action) => {
            state.fetching = "success";
            state.data = action.payload;
        },
        postOmuniFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
        },
        putOmuniRequest: (state) => {
            state.fetchingPut = "loading";
        },
        putOmuniSuccess: (state, action) => {
            state.fetchingPut = "success";
            state.data = action.payload;
        },
        putOmuniFailure: (state, action) => {
            state.fetchingPut = "failure";
            state.error = action.payload;
        },
        cleanOmuni: (state) => {
            state.fetchingPut = initialState.fetchingPut;
            state.fetching = initialState.fetching;
            state.error = initialState.error;
            state.data = initialState.data;
        },
    },
});

export const {
    postOmuniSuccess,
    postOmuniRequest,
    postOmuniFailure,
    putOmuniRequest,
    putOmuniSuccess,
    putOmuniFailure,
    cleanOmuni
} =
    omuniSlice.actions;

export default omuniSlice.reducer;
